import Cookies from "js-cookie";
import axios from "axios";
import { AppConstants } from "./constants";

export function logout() {
  localStorage.clear();
  sessionStorage.clear();
  Cookies.remove('acto', { path: '/', domain: `${AppConstants.domain}` })
  Cookies.remove('reto', { path: '/', domain: `${AppConstants.domain}` })
  // Cookies.remove('domain', { path: '/', domain: `${AppConstants.domain}` })
  localStorage.removeItem('persist:root')
  window.location.href =  `${AppConstants.redirect_url}`
}
const fetchRefresh = async () => {
  try {
    const response = await General.refresh();
    if (response) {
      if (response.status === 200) {
        Cookies.set('acto', response.data?.access_token, { path: '/', domain: `${AppConstants.domain}` })
        Cookies.set('reto', response.data?.refresh_token, { path: '/', domain: `${AppConstants.domain}` })


        // window.location.reload();
        // call api
      }
      if (response.status === 404) {
          window.location.href =  `${AppConstants.redirect_url}`
      }
    }
  } catch (error) {
    // throw error;
  }
};
// axios.defaults.baseURL = `${AppConstants.base_url_api}`;
axios.interceptors.request.use(
  (config) => {
    const token = ` ${Cookies.get('acto')}`;
    if (token) config.headers.Authorization = `${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(undefined, (error) => {
  if (error.message === "Network Error" && !error?.response) {

  }
  if (error.response) {
    const { status } = error?.response;
    if (status) {
      if (status === 401 || status === 403) {
        if (Cookies.get('reto')) {
          fetchRefresh()
        } else {
          window.location.href = `${AppConstants.redirect_url}`
        }
      }
      if (status === 200) {
        // return error;
      }
      if (status === 404) {
        // fetchRefresh()
        // return error;
      }
      if (status === 400) {

      }
      if (status === 500) {
        window.location.href = '/server-error'
      }
    }
  }

  throw error.response;
});

const responseBody = (response: any) => {
  return response;
};
const errorBody = (error: any) => {
  return error;
};

const requests = {
  get: (url: string) => axios.get(url).then(responseBody),
  post: (url: string, body: any) =>
    axios.post(url, body).then(responseBody).catch(errorBody),
  put: (url: string, body: any) => axios.put(url, body).then(responseBody).catch(errorBody),
  del: (url: string) => axios.delete(url).then(responseBody),
  postForm: (url: string, data: any) => {
    let formData = new FormData();
    // formData.append("insurance_type", insurance_type);
    Object.keys(data).forEach((key) => {
      if (data[key] !== null) {
        if (Array.isArray(data[key])) {
          data[key].forEach((item:any) => {
            formData.append(`${key}`, item); 
          });
        } else {
          formData.append(key, data[key]);
        }
      }
    });

    return axios
      .post(url, formData, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody);
  },
  putForm: (url: string, data: any) => {
    let formData = new FormData();
    // formData.append("insurance_type", insurance_type);
    Object.keys(data).forEach((key) => {
      if (data[key] !== null) {
        if (Array.isArray(data[key])) {
          data[key].forEach((item:any) => {
            formData.append(`${key}`, item); 
          });
        } else {
          formData.append(key, data[key]);
        }
      }
    });

    return axios
      .put(url, formData, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody);
  },
  postFormVideo: (url: string, Video: string | Blob) => {
    let formData = new FormData();
    formData.append('Video', Video);
    return axios
      .post(url, formData, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody);
  },
  pdf: (url: string) => {
    return axios
      .get(url, {
        headers: { "Content-type": "application/pdf" },
      })
      .then(responseBody);
  },

};
//

const General = {
  refresh: () => requests.post(`${process.env.REACT_APP_SSO_URL}/api/v1/refresh/`, { refresh: `${Cookies.get('reto')}` }),
  provinceList: () => requests.get(`${AppConstants.base_url_api}province-list`),
  cityList: (province_id: string) => requests.get(`${AppConstants.base_url_api}city-list/${province_id}`),

}
const User = {
  profile: () => requests.get(`${AppConstants.base_url_api}profile/`),
  updateProfile: (data:any) => requests.put(`${AppConstants.base_url_api}profile/` , data),
  contrant: (hasHeader?: boolean) => requests.get(`${AppConstants.base_url_api}profile/contract?is_header=${hasHeader ? "true" : "false"}`),
  sheba: (sheba_number: string) => requests.post(`${AppConstants.base_url_api}sheba`, { sheba_number: `IR${sheba_number}` }),
}
const universal = {
  list: () => requests.post(`${AppConstants.base_url_api}universal-offer/create`, {}),
}
const Dashboard = {
  list: () => requests.get(`${AppConstants.base_url_api}dashboard/`),
}
const Policies = {
  list: () => requests.get(`${AppConstants.base_url_api}policies/`),
  details: (id: string) => requests.get(`${AppConstants.base_url_api}policy/${id}`),
}

const limitationInquiry = {
  limitation: (insurance_type?:string) => requests.get(`${AppConstants.base_url_api}limitation-inquiry?insurance_type=${insurance_type}`),
  limitation2: (insurance_type?:string, contractNumber?:string) => requests.get(`${AppConstants.base_url_api}limitation-inquiry?insurance_type=${insurance_type}&contract_id=${contractNumber}`),
  job: (search_text?:string) => requests.get(`${AppConstants.base_url_api}job?search_text=${search_text}`),
  extrarisk: () => requests.get(`${AppConstants.base_url_api}extrarisk`),
  create: (data:any) => requests.post(`${AppConstants.base_url_api}universal-inquiry`, data),
  inqueryDefault: (policy_id:string) => requests.get(`${AppConstants.base_url_api}policy-identity-information?policy_id=${policy_id}`),
  issuingDefault: (policy_id:string) => requests.get(`${AppConstants.base_url_api}universal-offer-information?policy_id=${policy_id}`),
  paymentList: (queryParams?: string) => requests.get(`${AppConstants.base_url_api}paymentmethod${
    queryParams && `?${queryParams}`
  } `),
  inqueryConstraintValidated: (data:any) => requests.post(`${AppConstants.base_url_api}constraint-validated`, data),
  attachmentDefault: (contract_id:string , insurance_type : string) => requests.get(`${AppConstants.base_url_api}universal-limitation-attachment-default/?contract_id=${contract_id}`),
  universalOfferOtp: (data:any) => requests.post(`${AppConstants.base_url_api}universal-offer-otp/`, data),
  universalOfferOtpVerify: (data:any) => requests.postForm(`${AppConstants.base_url_api}universal-offer-otp_verify/`,data),
  uploadUniversalOffer: (data:any) => requests.postForm(`${AppConstants.base_url_api}upload-universal-offer/`,data),
  universalDraftOffer: (data:any) => requests.post(`${AppConstants.base_url_api}universal-draft-offer/`, data),
  universaHousingContractList: (id:any) => requests.get(`${AppConstants.base_url_api}universal-housing-Contract-List/?project_id=${id}`),
}
 const InqueryRegisterOffice = {
  inqueryRegisterOffice: (data:any) => requests.post(`${AppConstants.base_url_api}inquery-register-office`, data),

 }
 const RelationPerson = {
  relationPerson: () => requests.get(`${AppConstants.base_url_api}relation-person`),
 }


 const Questionnaire = {
  list: (isSelfsame:boolean) => requests.get(`${AppConstants.base_url_api}questionnaire?insured_equal_policy_holder=${isSelfsame}`),
 }
 const UniversalOffer = {
  create: (data:any) => requests.post(`${AppConstants.base_url_api}universal-offer/create`, data),
  list: (page:number,data:any) => requests.post(`${AppConstants.base_url_api}universal-offer/list/${page}`,data),
  deatils:(policy_id :string) => requests.get(`${AppConstants.base_url_api}offer/${policy_id}`)
 }
 const UniversalProjects = {
  list: (id:string) => requests.get(`${AppConstants.base_url_api}universal-projects/${id}`),
  create: (data:any) => requests.post(`${AppConstants.base_url_api}universalfound-offer/create`, data),
 }

 const HousingProject = {
  list: () => requests.get(`${AppConstants.base_url_api}housingprojects`),
  // details: (project_id :string) => requests.get(`${AppConstants.base_url_api}housingproject/${project_id }`),
  details: (project_id :string,contract_id:string) => requests.get(`${AppConstants.base_url_api}new-universal-projects/?project_id=${project_id}&contract_id=${contract_id }`),
  moreDetails: (project_id :string) => requests.get(`${AppConstants.base_url_api}doucument-universal-project/${project_id }`),
  create: (data:any) => requests.post(`${AppConstants.base_url_api}universalhousing-inquiry`, data),
  createOffer: (data:any) => requests.post(`${AppConstants.base_url_api}universalhousing-offer/create`, data),
  temporary: (token :string) => requests.get(`${process.env.REACT_APP_SSO_URL}/api/v1/temporary/?token=${token }`),
  setTemporary: (params:any) => requests.post(`${process.env.REACT_APP_SSO_URL}/api/v1/temporary/`,params),
 }
 const UniversalAttachment = { 
  create: (data:any) => requests.postForm(`${AppConstants.base_url_api}attachment`,data),
  details: (id:string) => requests.get(`${AppConstants.base_url_api}policies/${id}`)
 }
 const Payment = {
  prePayment: (data: any) => requests.post(`${AppConstants.base_url_api}pre-payment`, data),
  universalPrePayment:(data: any) => requests.post(`${AppConstants.base_url_api}universal-prepayment/`, data),
  universalPrePaymentUniversalHousing:(data: any) => requests.post(`${AppConstants.base_url_api}universal-prepayment-universal-housing/`, data),

  list: (page:number) => requests.get(`${AppConstants.base_url_api}transactions/?page=${page}`),
  
}
const UniversalReport = { 
  create: (data:any) => requests.post(`${AppConstants.base_url_api}universalreport/`, data),
  createOffer: (data:any) => requests.post(`${AppConstants.base_url_api}universalOfferreport`, data),
 }
 const LimitationBeneficiary = { 
  list: (queryParams?: string) =>
    requests.get(
      `${AppConstants.base_url_api}limitation-beneficiary${
        queryParams && `?${queryParams}`
      } `
    ),
 }
 const AgentCode = { 
  create: (code?: any) =>
    requests.post(
      `${AppConstants.base_url_api}agent_code/ ` , code
    ),
 }
 const Installment = {
  list: (data:any) => requests.post(`${AppConstants.base_url_api}installment/`,data),
  create: (id: number) => requests.post(`${AppConstants.base_url_api}universal-instalment/`,{id})
 }
 
export default {
  universal, User, General, Dashboard, Policies, UniversalReport , 
  limitationInquiry,
  InqueryRegisterOffice,
  RelationPerson, 
  Questionnaire,
  UniversalOffer,
  UniversalProjects,
  HousingProject,
  UniversalAttachment,
  Payment,
  Installment,
  LimitationBeneficiary,
  AgentCode
};

